import { createHbmlHeadersNodeComponents } from "./common/createHbmlHeadersNodeComponents";

export const HbmlHeaders3Node = createHbmlHeadersNodeComponents(3);
